function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawDashboard = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1130 868.1",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 340.5,
    y1: 874.69,
    x2: 340.5,
    y2: 452.37,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M1108.14 197.66a231.21 231.21 0 0 0-44.83-60.38l-621.86-5.18 512-60.79a337.39 337.39 0 0 0-103.88-17.42C800.28 20.24 736.93.05 667.83.05c-62 0-119.33 16.29-166.07 43.93-39.72-17.3-85-27.11-133.11-27.11-138.17 0-253.3 80.9-279.13 188.19zM1130 287.64a197 197 0 0 0-19.38-84.92L32.86 298.36a209.54 209.54 0 0 0-25.25 53.91l333.75 42.06L0 424.99c10.27 121.46 133.43 217.36 283.88 217.36 75.73 0 144.54-24.3 195.53-63.93 51.15 40.38 120.62 65.21 197.17 65.21 113.57 0 211.6-54.67 257.25-133.71 91.58-24.58 162.72-86.28 187.07-163.47l-422.07-55.34H1130v-3.47z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 499.98,
    cy: 855.15,
    rx: 289.98,
    ry: 12.94,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M672.09 832.39v7.82H440.84v-6.35a76 76 0 0 0 5.23-140.37h224.45a76 76 0 0 0 1.57 138.9z",
    fill: "#c8cad7"
  }), React.createElement("path", {
    d: "M670.52 693.49a76.11 76.11 0 0 0-42 50.39H488.08a76.13 76.13 0 0 0-42-50.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M176 653.65v43.9c0 24.24 17.74 43.89 39.63 43.89h680.42c21.89 0 39.63-19.65 39.63-43.89v-43.9z",
    fill: "#c8cad7"
  }), React.createElement("path", {
    d: "M672.09 832.39v7.82H440.84v-6.35a76 76 0 0 0 17.83-9.5h199.24a76.39 76.39 0 0 0 14.18 8.03z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 364.42,
    y: 826.8,
    width: 384.09,
    height: 23.17,
    rx: 9.5,
    ry: 9.5,
    fill: "#c8cad7"
  }), React.createElement("path", {
    d: "M935.68 172.62a39.62 39.62 0 0 0-39.63-39.57H215.66A39.62 39.62 0 0 0 176 172.62v489.57h759.68z",
    fill: "#474157"
  }), React.createElement("path", {
    d: "M915 190.3v420.67a19.5 19.5 0 0 1-19.51 19.51H216.27a19.5 19.5 0 0 1-19.51-19.51V190.3a19.51 19.51 0 0 1 19.51-19.51h679.17A19.51 19.51 0 0 1 915 190.3z",
    fill: "#4c4c78"
  }), React.createElement("circle", {
    cx: 555.85,
    cy: 151.89,
    r: 9.15,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 555.85,
    cy: 699.38,
    r: 22.56,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M348.53 180.55v449.93H216.27a19.5 19.5 0 0 1-19.51-19.51V190.3l.71-2.65 1.9-7.1z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#4c4c78",
    d: "M365.5 187.65v40.5H196.76V190.3l.71-2.65H365.5z"
  }), React.createElement("path", {
    d: "M915 190.3H196.76a19.5 19.5 0 0 1 19.51-19.5h679.17A19.5 19.5 0 0 1 915 190.3z",
    fill: "#c8cad7"
  }), React.createElement("circle", {
    cx: 216.27,
    cy: 180.55,
    r: 4.88,
    fill: "#ededf4"
  }), React.createElement("circle", {
    cx: 230.9,
    cy: 180.55,
    r: 4.88,
    fill: "#ededf4"
  }), React.createElement("circle", {
    cx: 245.53,
    cy: 180.55,
    r: 4.88,
    fill: "#ededf4"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M221.98 205.48h101.33v9.33H221.98z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M221.98 250.98h101.33v9.33H221.98zM221.98 283.15h101.33v9.33H221.98zM221.98 315.32h101.33v9.33H221.98zM221.98 347.48h101.33v9.33H221.98zM221.98 379.65h101.33v9.33H221.98zM221.98 411.82h101.33v9.33H221.98zM221.98 443.98h101.33v9.33H221.98z"
  }), React.createElement("path", {
    fill: "#dce0ed",
    opacity: 0.5,
    d: "M431.49 239.79H880.5v1.5H431.49zM431.49 274.62H880.5v1.5H431.49zM431.49 309.46H880.5v1.5H431.49zM431.49 344.29H880.5v1.5H431.49zM431.49 379.12H880.5v1.5H431.49z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M880.51 380.61H430.94v-68.5l41.23 20.32 42.67 5.78 37.44-11.29 45.17-35.03 22.72-13.12 16.61-3.2 15.89.85 26.14 12.91 35.52 22.63 27.88 3.59 22.11-7.62 46.85-38.38 23.92-8.53 25.03 3.87 20.39 11.77v103.95z"
  }), React.createElement("path", {
    d: "M509.3 338.23c-40.48 0-77.9-24.76-78.36-25.08l1.11-1.66c.58.39 58.16 38.49 107.09 19.4 17.86-6.95 30.54-17.78 42.86-28.24 12.83-10.93 24.95-21.26 41.46-25.74 19-5.13 39.65-.48 55.38 12.44 13.44 11.05 40.22 28.8 68.51 23.49 14.42-2.7 26.58-13.24 39.45-24.39 24.64-21.4 50.2-43.49 94.29-11.77l-1.17 1.62c-42.85-30.79-67.76-9.21-91.84 11.66-13.08 11.34-25.44 22-40.39 24.85-29.1 5.45-56.44-12.64-70.15-23.91-15.23-12.52-35.26-17-53.58-12.05-16.09 4.36-28 14.54-40.69 25.32-12.41 10.57-25.25 21.51-43.4 28.59a83.88 83.88 0 0 1-30.57 5.47z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 647.55,
    cy: 275.37,
    r: 11.13,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M403.62 533.19c-15.21-8.76-21-10.93-21-10.94l-.31-.22a12.66 12.66 0 0 1-3.84-4.85v-1 .1c.25-4.64 3.54-8.85 6.67-12.53q4-4.71 8-9.41a9.19 9.19 0 0 0 2.06-3.34 7.49 7.49 0 0 0 .22-2v-.82c0-2.34-.11-4.68-.19-7-.08-2.05-.6-4.62-2.65-5-1.06-.22-2.46.16-3-.75a1.68 1.68 0 0 1-.14-1.21v.09a.52.52 0 0 1 0-.11 27.65 27.65 0 0 0 .76-4.81 6.9 6.9 0 0 0-.33-2.43c-1.19-3.39-5.26-4.78-8.86-5.42s-7.64-1.19-9.9-4a32.74 32.74 0 0 0-2-2.71 7.88 7.88 0 0 0-3.69-1.82 20.72 20.72 0 0 0-13.38 1.17c-1.74.78-3.49 1.82-5.4 1.71s-3.68-1.5-5.64-1.83c-3.16-.54-6.19 1.79-7.75 4.54a11 11 0 0 0-1.43 5.35v.31a7.86 7.86 0 0 0 2.06 5.46c1.36 1.42 3.39 2.39 4 4.25.23.76.18 1.58.38 2.34 0 .1.06.19.09.29l-.11.13a23.77 23.77 0 0 0-5 14.62 24.26 24.26 0 0 0 17 23v.72a10.34 10.34 0 0 1-3.3 8.05l-21.58 8.66s-13-1.54-17.68 17.45a32.16 32.16 0 0 0-.8 9.63c.17 2.87-.23 7.91-3.56 14.43-5.33 10.44-4.12 34.39 6.78 36.76 10.29 2.24 14.32 1.31 14.74 1.2v.42c-.17 4.5-1.8 43.26-7.73 48-1.65 1.29-1.34 2.17 0 2.76v.7c-.18 2.84-1.1 13.63-5.07 19.78C307.48 690 308 731 308 731l-3.14 24.19s1.93 14.94 0 17.55c-1.73 2.33-4 57.61-4.52 69.59h-.2a5.83 5.83 0 0 0-4.66 2.84c-2.58 4.14-11.48 11.77-11.48 11.77-1.93 2.75-9.09 5.38-12.87 6.62a8.25 8.25 0 0 0-1.46.63 7.68 7.68 0 0 0-3.25 3.42 3.66 3.66 0 0 0-.34 2.85c1 2.37 21.07 4 26.15 1.66 4-1.86 19.84-4.32 26.42-5.28a5.42 5.42 0 0 0 4.7-4.7 3.1 3.1 0 0 0-.6-2.35c-1.26-1.56-1.91-5.82-2.2-8.6a5.85 5.85 0 0 0 1.48-.88 63.09 63.09 0 0 1 3.63-25.38c4.84-12.8 6.3-36.52 5.09-51.94 0 0 14.77-63.57 26.4-69.5.18.22 5.82 7.46 6.54 29.88.72 22.77 8.95 37.71 8.95 37.71s-3.63 38.66 0 53.13L367.87 847a7.39 7.39 0 0 1-.57-.52s.14.64.34 1.65l-.1.48.2.05c.54 2.85 1.34 7.82 1 10.74-.19 1.67-.65 3.94-1 6.18-.5 3.51-.64 6.92 1.21 7.66 3 1.22 20.83 2.89 23.86-1a5.61 5.61 0 0 0 .88-5.86 6 6 0 0 0-.88-1.49s-4.73-7.73-3.39-13.18a4 4 0 0 0-.57-3.12A161.08 161.08 0 0 1 393 823c3-11.41 9.42-36.43 4.72-52.89-.18-.64-.38-1.28-.6-1.9a71 71 0 0 1-2.67-27.75 56.41 56.41 0 0 1 0-24.19c2.88-13.27 4.91-26.27 4.91-26.27s1.6-17.55.2-28.31l-.09-.69.76-.17s-4.11-18.26-5.57-29.88c-.34-2.75-.79-6.22-1.28-9.93a26.22 26.22 0 0 0 3.95-1c13.08-4.51 17.19-45.31 17.19-45.31v-12.94s4.36-19.77-10.9-28.58zm-97.43 315l-.64-.34z",
    transform: "translate(-35 -15.95)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M360.73 752.65c5.67 16.31-1 42.78-4 54.6a165.7 165.7 0 0 0-4 26 55 55 0 0 1-20.8-.48l5-24.34c-3.54-14.42 0-52.95 0-52.95s-8-14.9-8.74-37.59c-.7-22.33-6.2-29.55-6.38-29.78-11.43 5.94-25.81 69.27-25.81 69.27 1.18 15.36-.24 39-5 51.77a64.05 64.05 0 0 0-3.55 25.29c-1.65 1.39-3.95 1.63-6.43 1.23-6.75-1.09-14.84-6.91-14.84-6.91s2.6-69 4.49-71.62 0-17.49 0-17.49l3.07-24.11s-.47-40.89 4-48c3.88-6.13 4.77-16.89 4.95-19.71v-.7l6.84-8.19s66.19-5 71.15 0c1.22 1.22 2 4 2.42 7.48 1.36 10.72-.2 28.21-.2 28.21s-2 13-4.82 26.23a57.4 57.4 0 0 0 0 24.11 72 72 0 0 0 2.65 27.68z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M356.59 856.3c-2.95 3.9-20.32 2.25-23.28 1-1.81-.75-1.67-4.14-1.18-7.64.31-2.23.76-4.5.94-6.15.48-4.26-1.41-12.89-1.41-12.89s3.9 4.14 4.84 0a4.5 4.5 0 0 1 3.37-3.2 8.84 8.84 0 0 1 6.14.38c3.07 1.33 8.19 4.17 7.27 8-1.3 5.43 3.31 13.13 3.31 13.13a5.93 5.93 0 0 1 .86 1.49 5.67 5.67 0 0 1-.86 5.88z",
    fill: "#a27772"
  }), React.createElement("path", {
    d: "M356.59 856.3c-2.95 3.9-20.32 2.25-23.28 1-1.81-.75-1.67-4.14-1.18-7.64 1.86.87 5 1.6 10.32 1.11a28.9 28.9 0 0 1 3.72-.12 85.06 85.06 0 0 0 11.28-.22 5.67 5.67 0 0 1-.86 5.87zM296 757.38c1.18 15.36-.24 39-5 51.77a64.05 64.05 0 0 0-3.55 25.29c-1.65 1.39-3.95 1.63-6.43 1.23 1.43-10 7.5-52.93 11.4-86.86 4.43-38.65 25.17-65.24 25.17-65.24l4.14 4.55c-11.35 5.93-25.73 69.26-25.73 69.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M349.5 508.95l-2.89 14.18-14.13 23.76-17.43-7.45s-23.7-24.82-8.81-28.36a13.13 13.13 0 0 0 4.95-2.2c2.92-2.21 3.84-5.41 3.86-8.55a26.29 26.29 0 0 0-2.42-10.17l30.49-9.57a48.52 48.52 0 0 0-2.19 12.35c-.23 8.3 2.85 12.4 5.38 14.35a9.06 9.06 0 0 0 3.19 1.66z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M343.12 480.59a48.52 48.52 0 0 0-2.19 12.35 24.1 24.1 0 0 1-25.88 7.39 26.29 26.29 0 0 0-2.42-10.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M346.61 476.69a24.11 24.11 0 1 1-24.11-24.11 24.05 24.05 0 0 1 24.11 24.11z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M349.5 508.95l-2.89 14.18-14.13 23.76-17.43-7.45s-23.7-24.82-8.81-28.36a13.13 13.13 0 0 0 4.95-2.2c-2.69 7.39 8.41 22.76 8.41 22.76 1.29 1.9 4.26.71 4.26.71 7.14-1.08 20.31-21.64 22.45-25.06a9.06 9.06 0 0 0 3.19 1.66zM363.15 646.44c-4.2 1-27.42 6.09-36.22 4.81-9.69-1.42-28.54-2.36-28.54-2.36s-12 .64-15.68-1v-.7l6.84-8.19s66.19-5 71.15 0c1.3 1.18 2 3.95 2.45 7.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M319.6 532.35s-12.47-17.27-7.77-24l-21.07 8.64s-12.68-1.54-17.25 17.38a33 33 0 0 0-.79 9.61c.17 2.85-.22 7.87-3.47 14.37-5.2 10.4-4 34.28 6.62 36.64s14.42 1.18 14.42 1.18-1.42 43.26-7.56 48.22 15.67 3.78 15.67 3.78 18.84 1 28.53 2.37 36.87-5 36.87-5-4-18.2-5.44-29.78-4.72-36.24-4.72-36.24l24.11-32.66s4.25-19.74-10.64-28.48-20.5-10.9-20.5-10.9-15 24.37-22.76 25.55c0 .02-2.96 1.22-4.25-.68z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M291.94 539.21s-.23 7.8 1.19 10.87 6.61 20.09 6.61 20.09h-11.81s6.38-6.85 5.91-10.16-1.9-20.8-1.9-20.8z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M326.93 598.05s-26.1-6.38-28.53-11.81-9.14-17.61-9.14-17.61l2.75-3.71 12.7 10s15.13 12 22.22 13.24 0 9.89 0 9.89z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M326.93 598.05s-26.1-6.38-28.53-11.81-9.14-17.61-9.14-17.61l2.75-3.71 12.7 10s15.13 12 22.22 13.24 0 9.89 0 9.89z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M349.5 567.34v14.16h-2.28a66.24 66.24 0 0 0-32.14 8.32l-4.26 2.36-1.15.64-7.33-16.5 6.86-6.15h.35c1.68.16 8.93.76 12-.27s6.55-4.14 15.14-1.94c4.24 1.08 7.85 5.83 12 4.35z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M372.31 541.57l4.73 5.32v12.88s-4 40.66-16.78 45.15-35.55-2.6-35.55-2.6-5.89-15.6-3.14-16.55 24.34-6.64 24.34-6.64-.31-23.85 4.42-30.94c0 0-3.07-22.22 7.56-22.69s14.42 16.07 14.42 16.07z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M373 541.57l4.73 5.32v12.88s-4 40.66-16.79 45.15-35.54-2.6-35.54-2.6-5.89-15.6-3.14-16.55 24.33-6.64 24.33-6.64-.3-23.85 4.43-30.94c0 0-3.08-22.22 7.56-22.69S373 541.57 373 541.57z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M340 486.93a9.31 9.31 0 0 0-.54-4.6 3.53 3.53 0 0 0-3.74-2.16c-2 .47-2.9 3.1-4.88 3.73-1.67.53-3.5-.65-4.3-2.21a11.3 11.3 0 0 1-.82-5.14v-5.93c0-2.15-.07-4.47-1.4-6.16-1.65-2.1-5.52-3-8.1-2.93a6.87 6.87 0 0 0-4.63 1.86 6 6 0 0 1-4.87 1.74 4.21 4.21 0 0 1-3.39-2.94.24.24 0 0 1 0-.08 24.11 24.11 0 1 1 35.86 32 66.79 66.79 0 0 0 .81-7.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M306.71 464.42a4.24 4.24 0 0 1-3.4-2.94c-.19-.76-.14-1.58-.37-2.33-.55-1.86-2.53-2.83-3.86-4.24-2.66-2.82-2.49-7.47-.61-10.87 1.53-2.74 4.48-5.05 7.57-4.52 1.91.34 3.56 1.7 5.5 1.82s3.57-.92 5.27-1.7a19.84 19.84 0 0 1 13.06-1.16 7.56 7.56 0 0 1 3.6 1.81 30.59 30.59 0 0 1 1.92 2.7c2.2 2.81 6.15 3.36 9.66 4s7.49 2 8.64 5.41c.77 2.24 0 4.67-.41 7a2 2 0 0 0 .09 1.45c.55.91 1.92.53 3 .74 2 .42 2.5 3 2.57 5q.14 3.48.19 7a9 9 0 0 1-.2 2.59 9.17 9.17 0 0 1-2 3.25l-7.81 9.38c-3.46 4.16-7.13 9-6.44 14.37-1.64.73-3.58-.68-4.12-2.4s-.11-3.56.26-5.32a65.36 65.36 0 0 0 1.23-9.23 9.34 9.34 0 0 0-.54-4.61 3.54 3.54 0 0 0-3.75-2.16c-2 .47-2.89 3.1-4.87 3.73-1.67.54-3.5-.65-4.3-2.21a11.43 11.43 0 0 1-.82-5.14v-5.93c0-2.15-.07-4.47-1.4-6.16-1.64-2.1-5.52-3-8.1-2.93a6.87 6.87 0 0 0-4.63 1.86 6 6 0 0 1-4.93 1.74z",
    fill: "#7c5c5c"
  }), React.createElement("path", {
    d: "M312.15 538.62l7.41 30.4s5.83-.03-7.41-30.4zM337.45 533.53s-9.7 15.88-5.91 32.29l1.8.13s-3.22-7.6 4.11-32.42zM343.59 623.36s11.9-3.94 12.77 5.2c0 0-2.25-6.27-12.77-5.2zM309.2 570.88s-2.36 16.55 1.89 23.17a51.94 51.94 0 0 1-20.8 2.83l-1.42-26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M310.82 592.18l-1.15.64-7.33-16.5 6.86-6.15h.35c-.11.8-2.02 15.01 1.27 22.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M309.2 570.17s-2.36 16.55 1.89 23.17a51.94 51.94 0 0 1-20.8 2.83l-8.27-26z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M288.75 846.24a5.34 5.34 0 0 1-4.59 4.68c-6.41 1-21.88 3.4-25.78 5.26-5 2.37-24.58.71-25.53-1.65a3.75 3.75 0 0 1 .34-2.85 7.79 7.79 0 0 1 4.59-4c3.7-1.24 10.68-3.85 12.56-6.59 0 0 8.7-7.62 11.18-11.73a5.66 5.66 0 0 1 4.55-2.83c2.07-.1 4.37.95 5.32 5.48 0 0 11.34 6.47 14.41.8 0 0 .47 8.71 2.35 11.1a3.13 3.13 0 0 1 .6 2.33z",
    fill: "#a27772"
  }), React.createElement("path", {
    d: "M288.75 846.24a5.34 5.34 0 0 1-4.59 4.68c-6.41 1-21.88 3.4-25.78 5.26-5 2.37-24.58.71-25.53-1.65a3.75 3.75 0 0 1 .34-2.85 7.57 7.57 0 0 1 3.17-3.4c3.2 2.12 10.3 4.2 25.92 1.76 14.9-2.33 22.27-4.61 25.87-6.16a3.13 3.13 0 0 1 .6 2.36z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M353.25 459.72a.5.5 0 0 0 0-.12 21.55 21.55 0 0 0 .73-5.36 33.89 33.89 0 0 1-.73 4.3 2.62 2.62 0 0 0 0 1.18zM339.46 481.84a7 7 0 0 1 .58 2.7 8.11 8.11 0 0 0-.58-3.76 3.55 3.55 0 0 0-3.75-2.17c-2 .47-2.89 3.11-4.87 3.74-1.67.53-3.5-.66-4.3-2.22a11.17 11.17 0 0 1-.82-5.14v-5.92c0-2.15-.07-4.47-1.4-6.16-1.65-2.11-5.52-3-8.11-2.94a6.83 6.83 0 0 0-4.62 1.87 6 6 0 0 1-4.87 1.73 4.19 4.19 0 0 1-3.4-2.94c-.2-.76-.14-1.57-.37-2.33-.55-1.86-2.53-2.82-3.86-4.23a7.78 7.78 0 0 1-2-5 8.09 8.09 0 0 0 2 6.06c1.33 1.41 3.31 2.38 3.86 4.24.23.75.17 1.57.37 2.33a4.23 4.23 0 0 0 3.4 2.94 6 6 0 0 0 4.87-1.74 6.93 6.93 0 0 1 4.61-1.85c2.59-.08 6.46.84 8.11 2.94 1.33 1.69 1.39 4 1.4 6.16v5.92a11.19 11.19 0 0 0 .82 5.15c.8 1.56 2.63 2.74 4.3 2.21 2-.63 2.85-3.26 4.87-3.74a3.57 3.57 0 0 1 3.76 2.15zM358.89 475.33a9.3 9.3 0 0 1-2 3.26q-3.92 4.68-7.81 9.37c-3.28 3.95-6.76 8.52-6.51 13.56.24-4.62 3.46-8.82 6.51-12.49l7.81-9.38a9.26 9.26 0 0 0 2-3.25 9 9 0 0 0 .2-2.6 6.48 6.48 0 0 1-.2 1.53zM338.51 499.94a5.58 5.58 0 0 1-.24-1.27 6.33 6.33 0 0 0 .24 2.33c.53 1.72 2.48 3.13 4.12 2.4 0-.35-.07-.7-.08-1-1.62.65-3.55-.78-4.04-2.46z"
  })), React.createElement("path", {
    d: "M260 831.47s2.47 4.34 11.43.51M335.65 832.51s7.73 9.09 17.46 3M358.13 724.99s-5.46 3.41-5.64 5.36 2.82-1.42 2.82-1.42zM360.28 751.13a11.33 11.33 0 0 1-6.72 2.62c-4.08.18-3.74 5.5-1.07 3.9s7.79-6.52 7.79-6.52zM361.32 754.54s-2.62 12.86-4.75 10.38",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.5,
    fill: "#dce0ed"
  }, React.createElement("path", {
    d: "M471.17 458.65h66v14h-66zM622.72 458.65h66v14h-66zM774.27 458.65h66v14h-66z"
  })), React.createElement("ellipse", {
    cx: 952.73,
    cy: 801.29,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 115.22,
    cy: 858.74,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 893.79,
    cy: 850.05,
    rx: 40.21,
    ry: 6.8,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M910.41 838.94a11.64 11.64 0 0 0 3.83-5.79c.5-2.3-.48-5.05-2.67-5.89-2.46-.94-5.09.76-7.09 2.49s-4.27 3.68-6.88 3.32a10.5 10.5 0 0 0 3.24-9.81 4.08 4.08 0 0 0-.9-2c-1.37-1.46-3.84-.84-5.48.31-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.64-6.23a8 8 0 0 0-4-.94c-2.34-.09-4.95.14-6.54 1.85-2 2.13-1.47 5.69.25 8s4.36 3.8 6.77 5.42a15.13 15.13 0 0 1 4.84 4.61 4.81 4.81 0 0 1 .35.83h14.66a41.11 41.11 0 0 0 9.03-6.25zM116.45 791.24s5.5 7.19-2.53 18-14.65 20-12 26.77c0 0 12.12-20.15 22-20.43s3.38-12.22-7.47-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M116.45 791.24a9 9 0 0 1 1.13 2.26c9.62 11.3 14.74 21.85 5.49 22.11-8.61.25-18.94 15.65-21.42 19.54a9.24 9.24 0 0 0 .29.89s12.12-20.15 22-20.43 3.36-12.25-7.49-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M126.66 800.4c0 2.53-.28 4.58-.63 4.58s-.63-2-.63-4.58.35-1.34.7-1.34.56-1.19.56 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M130.17 803.42c-2.22 1.21-4.16 1.94-4.32 1.63s1.49-1.54 3.71-2.75 1.35-.33 1.51 0 1.32-.09-.9 1.12z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M87.44 791.24s-5.5 7.19 2.53 18 14.65 20 12 26.77c0 0-12.11-20.15-22-20.43s-3.38-12.22 7.47-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M87.44 791.24a9 9 0 0 0-1.13 2.26c-9.62 11.3-14.74 21.85-5.49 22.11 8.61.25 18.94 15.65 21.42 19.54a7.16 7.16 0 0 1-.3.89s-12.11-20.15-22-20.43-3.35-12.25 7.5-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M77.22 800.4c0 2.53.29 4.58.64 4.58s.63-2 .63-4.58-.35-1.34-.7-1.34-.57-1.19-.57 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M73.72 803.42c2.22 1.21 4.15 1.94 4.32 1.63s-1.49-1.54-3.71-2.75-1.35-.33-1.52 0-1.31-.09.91 1.12z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M79 835.1s15.36-.48 20-3.77 23.63-7.24 24.78-1.95 23.08 26.29 5.74 26.43-40.29-2.7-44.91-5.51S79 835.1 79 835.1z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M129.79 853.97c-17.34.14-40.3-2.7-44.92-5.51-3.51-2.15-4.92-9.84-5.38-13.38h-.52s1 12.38 5.6 15.2 27.57 5.65 44.91 5.51c5 0 6.73-1.82 6.64-4.46-.7 1.62-2.61 2.61-6.33 2.64z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M466.5 556.42c0-20.44 16.63-36.14 37.08-36.14h.29v-9.3h-.29c-25.58 0-46.38 19.87-46.38 45.44a46.26 46.26 0 0 0 15.89 34.9l6.59-6.59a37 37 0 0 1-13.18-28.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M504.8 510.99v9.3a37.07 37.07 0 1 1-24.19 65.37l-6.61 6.59a46.36 46.36 0 1 0 30.78-81.26zM808.8 519.81c20.44 0 36.14 16.63 36.14 37.08v.29h9.3v-.29c0-25.57-19.87-46.38-45.44-46.38a46.24 46.24 0 0 0-34.9 15.89l6.59 6.59a37 37 0 0 1 28.31-13.18z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M854.23 558.11h-9.3a37.07 37.07 0 1 1-65.37-24.19l-6.56-6.59a46.36 46.36 0 1 0 81.26 30.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M674 513.71l-1.85 9.26c13.61 5.49 22.31 18.83 22.31 34.38a37.07 37.07 0 1 1-51.93-33.95l-4.12-8.35a46.36 46.36 0 1 0 65.39 42.3c0-20.07-11.88-37.19-29.8-43.64z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M658.59 519.74a32.38 32.38 0 0 1 12.91 2.68l1.85-9.25a40.9 40.9 0 0 0-14.76-2.73 46.17 46.17 0 0 0-19 4.09l4.16 8.33a36.69 36.69 0 0 1 14.84-3.12z",
    fill: primaryColor
  }));
};

UndrawDashboard.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawDashboard;